import React, { useState, useRef } from "react";
import "./style.css";
import { faChevronRight } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export function Accordion({ title, children }) {
  const [setActive, setActiveState] = useState("");
  const [setHeight, setHeightState] = useState("0px");
  const [setRotate, setRotateState] = useState("accordion__icon");

  const content = useRef(null);

  function toggleAccordion() {
    setHeightState(
      setActive === "active" ? `${content.current.scrollHeight}px` : "0px"
    );
    setActiveState(setActive === "" ? "active" : "");
    setTimeout(() => {
      setHeightState(
        setActive === "active" ? "0px" : `${content.current.scrollHeight}px`
      );
    }, 1);
    setTimeout(() => {
      setHeightState(setActive === "active" ? "0px" : "fit-content");
    }, 600);
    setRotateState(
      setActive === "active" ? "accordion__icon" : "accordion__icon rotate"
    );
  }

  return (
    <div className="accordion__section">
      <button className={`accordion ${setActive}`} onClick={toggleAccordion}>
        <p className="accordion__title">{title}</p>
        <FontAwesomeIcon icon={faChevronRight} className={`${setRotate}`} />
      </button>
      <div
        ref={content}
        style={{ maxHeight: `${setHeight}` }}
        className="accordion__content"
      >
        <div className="accordion__text">{children}</div>
      </div>
    </div>
  );
}

export default Accordion;
